import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

/* Function */
import ObjGeneral from '../function';
import Constants from '../function/constants';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as tasksManagerActions from '../../actions/tasks_manager/index';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import TasksManagerTabTasks from '../../components/tasks_manager/tasksManagerTabTasks';
import TasksManagerTabNotifications from '../../components/tasks_manager/tasksManagerTabNotifications';
import { Badge } from '../../components/common/badge';
import Header from '../../components/tasks_manager/header';
import Message from '../../components/common/message';
import Loading from '../../components/common/loading';

// variable that allows you to determine if all the tabs are rendered when the component is loaded (true)
// or if they are rendered one by one when they are selected (false)
const FORCE_RENDER_TAB_PANEL_DEFAULT = false;

// this list contains all tabs that can be drawn, their location is the order in which they are displayed.
const TAB_LIST = [
  {
    key: Constants.taskManagerTabs.TAB_TASKS,
    component: TasksManagerTabTasks,
    showTab: false,
  },
  {
    key: Constants.taskManagerTabs.TAB_NOTIFICATIONS,
    component: TasksManagerTabNotifications,
    showTab: false,
  },
];

export class TasksManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      params: props.match.params,
      indexTabSelected: 0,
      totalVisibleTabs: -1,
    };
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('task');

    if (permit) {
      const obj = JSON.parse(this.props.setting.value);

      if (obj.generalSetting.views.includes('task')) {
        // gets data to use in all tab filters
        await this.props.actions.fetchTasksManagerFilters({});

        // assign common filters to all tabs in the reducer
        this.props.actions.setFilterTasksManager({
          date: this.props.filters.date,
          tags: this.props.filters.tags,
          personId: this.props.filters.personId,
          type: this.props.filters.type,
          subtype: this.props.filters.subtype
        });

        // check the permissions that the user has on the tabs
        this.getVisibleTabs();
      } else {
        this.props.history.push('/dashboard/authorization');
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.headerActions.resetHeader();
  }

  /**
   * gets the tabs that are visible
   */
  getVisibleTabs = () => {
    const { taskManagerTabs  } = Constants;
    const tabList = [...TAB_LIST];
    let totalVisibleTabs = 0;
    let indexTab = 0;

    // ---------------------------------------------------------
    // TODO: use these variables to get the actual permissions
    // ---------------------------------------------------------
    const visibleTabTasks = true;
    const visibleTabNotifications = true;

    // go through the tabs to obtain and update information of each one of them
    tabList.map((tab) => {
      switch (tab.key) {
        case taskManagerTabs.TAB_TASKS:
          tab.showTab = visibleTabTasks;
          break;
        case taskManagerTabs.TAB_NOTIFICATIONS:
          tab.showTab = visibleTabNotifications;
          break;
      }

      // if you have permission, count it
      if (tab.showTab) {
        totalVisibleTabs++;

        // assign the index of the tab
        tab.index = indexTab;

        // increments the index to assign it to the next tab to be displayed
        indexTab++;
      } else {
        tab.index = -1;
      }
      return tab;
    });

    this.setState({
      totalVisibleTabs,
    })
  }

  /**
   * gets the total of unmanaged tasks
   * @param {String} key tab key
   * @returns object with total unmanaged tasks
   */
  getUnmanagedTasks = (key) => {
    const { taskManagerTabs  } = Constants;
    const { language, datosTabTasks, datosTabNotifications } = this.props;
    let data = null;
    let total = 0;
    const distribution = [];

    // obtains data from the distribution according to the selected tab
    switch (key) {
      case taskManagerTabs.TAB_TASKS:
        data = datosTabTasks;
        break;
      case taskManagerTabs.TAB_NOTIFICATIONS:
        data = datosTabNotifications;
        break;
    }

    if (data && data.stats) {
      // obtains from the distribution the records that are Overdue and Open
      const findDistributionOverdue = data.stats.distribution.find(item => item.key === 'Overdue');
      const findDistributionOpen = data.stats.distribution.find(item => item.key === 'Open');

      if (findDistributionOverdue) {
        total += findDistributionOverdue.quantity;
        distribution.push(`${language.tasks_manager.states[findDistributionOverdue.key.toUpperCase()]}: ${findDistributionOverdue.quantity}`);
      }

      if (findDistributionOpen) {
        total += findDistributionOpen.quantity;
        distribution.push(`${language.tasks_manager.states[findDistributionOpen.key.toUpperCase()]}: ${findDistributionOpen.quantity}`);
      }
    }

    let resp = '';
    if (total > 0) {
      resp = (total < 99) ? total.toString() : '99+';
    }

    return {
      total: resp,
      distribution: distribution.join(', ')
    };
  }

  /**
   * gets information associated with each visible tab
   * @returns object with the information of each visible tab
   */
  getInformationTabs = () => {
    const { taskManagerTabs  } = Constants;
    const tabList = [...TAB_LIST];

    // go through the tabs to obtain and update information of each one of them
    tabList.map((tab) => {
      switch (tab.key) {
        case taskManagerTabs.TAB_TASKS:
          tab.title = this.props.language.tasks_manager.tab.tasks;
          tab.handleSubmit = (window._TasksManagerTabTasks) ? window._TasksManagerTabTasks.handleSubmit : () => {};
          break;
        case taskManagerTabs.TAB_NOTIFICATIONS:
          tab.title = this.props.language.tasks_manager.tab.notifications;
          tab.handleSubmit = (window._TasksManagerTabNotifications) ? window._TasksManagerTabNotifications.handleSubmit : () => {};
          break;
      }

      tab.totalUnmanagedTasks = this.getUnmanagedTasks(tab.key);

      return tab;
    });

    // gets only the tabs that have permissions to be displayed
    let findVisibleTabs = [];
    if (this.state.totalVisibleTabs > 0) {
      findVisibleTabs = tabList.filter(item => item.showTab);
    }

    return {
      totalVisibleTabs: this.state.totalVisibleTabs,
      tabList: findVisibleTabs
    };
  }

  /**
   * assigns the index of the selected tab to the component state
   * @param {Number} index tab index
   */
  handleTabSelect = (index) => {
    this.setState({ indexTabSelected: index });
  }

  /**
   * handles sending the data to perform the search
   * @param {Object} obj object with search filters
   */
  handleSubmit = (obj) => {
    const tabList = [...TAB_LIST];
    const objDate = JSON.parse(this.props.setting.value);
    const format = objDate.generalSetting.formatDate;
    const tags = (obj.multipleTagsInputIsMultiple) ? ObjGeneral.getTags(obj) : this.props.filters.tags;
    const date = ObjGeneral.getDate(obj, format);
    const personId = ObjGeneral.getPersonId(obj, this.props.filters.datos.persons);
    const { type, subtype } = ObjGeneral.getTypeSubtype(obj, this.props.filters.datos.types);

    // assign common filters to all tabs in the reducer
    this.props.actions.setFilterTasksManager({
      date,
      tags,
      personId,
      type,
      subtype
    });

    // if they render all the tabs, then it executes all the handleSubmits of the tabs that are visible
    if (FORCE_RENDER_TAB_PANEL_DEFAULT) {
      tabList.map((tab) => {
        if (tab.showTab) {
          tab.handleSubmit(obj);
        }
      });
    } else {
      // otherwise it only executes the handleSubmit of the selected tab
      const findTab = tabList.find(item => item.index === this.state.indexTabSelected);
      findTab.handleSubmit(obj);
    }
  }

  render() {
    if (this.props.setting) {
      // the setting object is obtained which we use for the configuration
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.taskManager,
        filter: this.props.filter,
        general: obj.generalSetting,
        isEnabledUbicationPVT: ObjGeneral.getIsEnabledUbicationPVT(obj),
        filterUbicationPVT: this.props.filterUbicationPVT
      });
      const { params } = this.state;

      // gets all the information from the tabs to draw it
      const { totalVisibleTabs, tabList } = this.getInformationTabs();

      // if you do not have permissions to view the tabs, show a message
      if (totalVisibleTabs === 0) {
        return (
          <section className="main">
            <Message message={this.props.language.tasks_manager.tab.not_tabs_assigned} />
          </section>
        )
      }

      // if you have permissions, determine how they should be displayed
      return (
        <section className="main">
          <Header
            loadingFilter={this.props.loadingFilter}
            filter={setting.filter}
            filters={this.props.filters}
            handleSubmit={this.handleSubmit}
            language={this.props.language}
            date={this.props.dateMax[8]}
            defaultRangeInDay={obj.taskManager.defaultRangeInDay}
          />
          {
            (this.props.loadingFilter || this.props.filters.loading) && (
              <Loading language={this.props.language} />
            )
          }
          {
            (!this.props.loadingFilter && !this.props.filters.loading) && (
              <Fragment>
                {/* if you have permission to see only one tab, then it shows it in the whole container */}
                {
                  (totalVisibleTabs === 1) && (
                    tabList.map((tab) => {
                      const TabComponent = tab.component;
                      return (
                        <TabComponent
                          key={`tab-${tab.index}`}
                          params={params}
                          containerClassName="main-without-tabs"
                          history={this.props.history}
                        />
                      )
                    })
                  )
                }

                {/* if you have permission to see more than one tab, then show them inside the tab container */}
                {
                  (totalVisibleTabs > 1) && (
                    <div className="main-container-tabs">
                      <div className="main-container-tabs-wrapper">
                        <Tabs
                          forceRenderTabPanel={FORCE_RENDER_TAB_PANEL_DEFAULT}
                          disableUpDownKeys={true}
                          onSelect={(index) => this.handleTabSelect(index)}
                        >
                          <TabList>
                            {
                              // draw all tab titles
                              tabList.map((tab) => {
                                return (
                                  <Tab key={`tab-${tab.index}`} className={`react-tabs__tab tour-tab__${tab.key.toLowerCase()}`}>
                                    <div className="badge-wrapper">
                                      <span className="react-tabs__title">{tab.title}</span>
                                      {
                                        tab.totalUnmanagedTasks.total !== '' && (
                                          <Badge
                                            title={tab.totalUnmanagedTasks.total}
                                            tooltip={tab.totalUnmanagedTasks.distribution}
                                            color={(tab.index === this.state.indexTabSelected) ? 'danger' : 'light'}
                                            containerClassName={`main-container-tabs-badge tour-tab-badge__${tab.key.toLowerCase()}`}
                                          />
                                        )
                                      }
                                    </div>
                                  </Tab>
                                )
                              })
                            }
                          </TabList>

                          {
                            // draw all tab containers
                            tabList.map((tab) => {
                              const TabComponent = tab.component;
                              return (
                                <TabPanel key={`tab-panel-${tab.index}`}>
                                  <TabComponent
                                    params={params}
                                    containerClassName="main-inside-tabs"
                                    history={this.props.history}
                                  />
                                </TabPanel>
                              )
                            })
                          }
                        </Tabs>
                      </div>
                    </div>
                  )
                }
              </Fragment>
            )
          }
        </section>
      )
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  filterUbicationPVT: state.reducer.tags.filterUbicationPVT,
  loadingFilter: state.reducer.tags.loading,
  setting: state.reducer.dashboard.setting,
  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language,

  filters: state.reducer.tasksManager.filters,

  datosTabTasks: state.reducer.tasksManagerTabTasks.datos,
  datosTabNotifications: state.reducer.tasksManagerTabNotifications.datos,
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tasksManagerActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});
TasksManager.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksManager);



// WEBPACK FOOTER //
// ./source/client/containers/tasks_manager/index.jsx